import { render, staticRenderFns } from "./RUInfoDialog.vue?vue&type=template&id=eed77eea&scoped=true"
import script from "./RUInfoDialog.vue?vue&type=script&lang=js"
export * from "./RUInfoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eed77eea",
  null
  
)

export default component.exports